<template>
	<div class="mb-1 clearfix">
		<div class="alert pb-2 pt-2 pl-2 pr-2 text-white" :class="passClass">
			<div class="float-left mr-4">
				<b-icon :icon="iconName" style="width: 30px; height: 30px"></b-icon>
			</div>
			<p class="mb-0 mt-0 lh-1 font-bold">{{ settings.caption }}</p>
			<p class="mb-0 mt-0 lh-1">{{ passMessage }}</p>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	props: {
		settings: Object
	},
	data() {
		return {
		};
	},
	mounted() {
	},
	watch: {
	},
	computed: {
		passMessage() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return '...';
			}
			if(this.settings.value !== 0){
				return this.$t('passed-colon-{n}' , {n: this.$datetime.timestampToDate(this.settings.value)});
			}
			return this.$t('not-passed');
		},
		passType() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return '';
			}
			if(this.settings.value !== 0){
				return 'pass';
			}
			return 'fail';
		},
		passClass() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return 'skeleton midnight muted';
			}
			if (this.settings.value !== 0) {
				return "bg-success";
			} else {
				return "bg-danger";
			}
		},
		iconName() {
			if(!('ready' in this.settings) || !this.settings.ready){
				return 'circle-fill';
			}
			if (this.settings.value !== 0) {
				return "check-circle-fill";
			} else {
				return "x-circle-fill";
			}
		}
	}
};
</script>
